/**
 * @generated SignedSource<<e6b1d2152806117f2dd5e3e224310d37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type personalizedNotificationTemplateEdit_Query$variables = {
  id: string;
};
export type personalizedNotificationTemplateEdit_Query$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment">;
  } | null;
};
export type personalizedNotificationTemplateEdit_Query = {
  response: personalizedNotificationTemplateEdit_Query$data;
  variables: personalizedNotificationTemplateEdit_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "personalizedNotificationTemplateEdit_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment"
              }
            ],
            "type": "PersonalizedNotificationTemplate",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "personalizedNotificationTemplateEdit_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationTemplate",
                "kind": "LinkedField",
                "name": "template",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "message",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "variables",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "PersonalizedNotificationTemplate",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "243a7b509a6575d193708dcf122fa407",
    "id": null,
    "metadata": {},
    "name": "personalizedNotificationTemplateEdit_Query",
    "operationKind": "query",
    "text": "query personalizedNotificationTemplateEdit_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on PersonalizedNotificationTemplate {\n      ...personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment\n    }\n    id\n  }\n}\n\nfragment personalizedNotificationTemplateEdit_PersonalizedNotificationTemplateFragment on PersonalizedNotificationTemplate {\n  id\n  template {\n    key\n    title\n    message\n    variables\n  }\n}\n"
  }
};
})();

(node as any).hash = "ad9936cbcb5eb44f88237f46649f88af";

export default node;
